module.exports = __webpack_public_path__ + "assets/instagram.3c417b13.svg";